var _rect, _circle, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 260,
    fill: "#f5f5f5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 40,
    fill: "#d3d3d3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 150 C50 150 25 200 25 260 L175 260 C175 200 150 150 100 150Z",
    fill: "#d3d3d3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 258,
    x: 1,
    y: 1,
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.eb506969329eeb4eaeccaf35ace49d63.svg";
export { ForwardRef as ReactComponent };